import { TenantEntity } from '@/class/model/TenantEntity'

export class MblTemporaryStorage extends TenantEntity {
  constructor(data) {
    super(data)
    this.className = 'MblTemporaryStorage'
  }

  get jobUuid() {
    return this._data.jobUuid
  }

  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }

  get mbl() {
    return this._data.mbl
  }

  set mbl(mbl) {
    this._data.mbl = mbl
  }

  get purchaseMethod() {
    return this._data.purchaseMethod
  }

  set purchaseMethod(purchaseMethod) {
    this._data.purchaseMethod = purchaseMethod
  }

  get purchaseSource() {
    return this._data.purchaseSource
  }

  set purchaseSource(purchaseSource) {
    this._data.purchaseSource = purchaseSource
  }

  get serviceProduct() {
    return this._data.serviceProduct
  }

  set serviceProduct(serviceProduct) {
    this._data.serviceProduct = serviceProduct
  }

  get airlineProductUuid() {
    return this._data.airlineProductUuid
  }

  set airlineProductUuid(airlineProductUuid) {
    this._data.airlineProductUuid = airlineProductUuid
  }

  get voyageFlight() {
    return this._data.voyageFlight
  }

  set voyageFlight(voyageFlight) {
    this._data.voyageFlight = voyageFlight
  }

  get carrierId() {
    return this._data.carrierId
  }

  set carrierId(carrierId) {
    this._data.carrierId = carrierId
  }

  get etd() {
    return this._data.etd
  }

  set etd(etd) {
    this._data.etd = etd
  }
  get operateType() {
    return this._data.operateType
  }

  set operateType(operateType) {
    this._data.operateType = operateType
  }
  get opDepartment() {
    return this._data.opDepartment
  }

  set opDepartment(opDepartment) {
    this._data.opDepartment = opDepartment
  }

  get portOfDeparture() {
    return this._data.portOfDeparture
  }

  set portOfDeparture(portOfDeparture) {
    this._data.portOfDeparture = portOfDeparture
  }

  get transitPort1() {
    return this._data.transitPort1
  }

  set transitPort1(transitPort1) {
    this._data.transitPort1 = transitPort1
  }

  get transitPort2() {
    return this._data.transitPort2
  }

  set transitPort2(transitPort2) {
    this._data.transitPort2 = transitPort2
  }

  get destinationPortCode() {
    return this._data.destinationPortCode
  }

  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }

  get secondFlight() {
    return this._data.secondFlight
  }

  set secondFlight(secondFlight) {
    this._data.secondFlight = secondFlight
  }

  get secondCarrierId() {
    return this._data.secondCarrierId
  }

  set secondCarrierId(secondCarrierId) {
    this._data.secondCarrierId = secondCarrierId
  }

  get secondMbl() {
    return this._data.secondMbl
  }

  set secondMbl(secondMbl) {
    this._data.secondMbl = secondMbl
  }

  get secondEtd() {
    return this._data.secondEtd
  }

  set secondEtd(secondEtd) {
    this._data.secondEtd = secondEtd
  }

  get secondEta() {
    return this._data.secondEta
  }

  set secondEta(secondEta) {
    this._data.secondEta = secondEta
  }

  get thirdFlight() {
    return this._data.thirdFlight
  }

  set thirdFlight(thirdFlight) {
    this._data.thirdFlight = thirdFlight
  }

  get thirdCarrierId() {
    return this._data.thirdCarrierId
  }

  set thirdCarrierId(thirdCarrierId) {
    this._data.thirdCarrierId = thirdCarrierId
  }

  get thirdMbl() {
    return this._data.thirdMbl
  }

  set thirdMbl(thirdMbl) {
    this._data.thirdMbl = thirdMbl
  }

  get thirdEtd() {
    return this._data.thirdEtd
  }

  set thirdEtd(thirdEtd) {
    this._data.thirdEtd = thirdEtd
  }

  get thirdEta() {
    return this._data.thirdEta
  }

  set thirdEta(thirdEta) {
    this._data.thirdEta = thirdEta
  }

  get quantityBooking() {
    return this._data.quantityBooking
  }

  set quantityBooking(quantityBooking) {
    this._data.quantityBooking = quantityBooking
  }

  get weightBooking() {
    return this._data.weightBooking
  }

  set weightBooking(weightBooking) {
    this._data.weightBooking = weightBooking
  }

  get cubageBooking() {
    return this._data.cubageBooking
  }

  set cubageBooking(cubageBooking) {
    this._data.cubageBooking = cubageBooking
  }

  get chargeWeightBooking() {
    return this._data.chargeWeightBooking
  }

  set chargeWeightBooking(chargeWeightBooking) {
    this._data.chargeWeightBooking = chargeWeightBooking
  }

  get densityBooking() {
    return this._data.densityBooking
  }

  set densityBooking(densityBooking) {
    this._data.densityBooking = densityBooking
  }

  get bookingDimensions() {
    return this._data.bookingDimensions
  }

  set bookingDimensions(bookingDimensions) {
    this._data.bookingDimensions = bookingDimensions
  }

  get quantityActual() {
    return this._data.quantityActual
  }

  set quantityActual(quantityActual) {
    this._data.quantityActual = quantityActual
  }

  get weightActual() {
    return this._data.weightActual
  }

  set weightActual(weightActual) {
    this._data.weightActual = weightActual
  }

  get cubageActual() {
    return this._data.cubageActual
  }

  set cubageActual(cubageActual) {
    this._data.cubageActual = cubageActual
  }

  get cWeight() {
    return this._data.cWeight
  }

  set cWeight(cWeight) {
    this._data.cWeight = cWeight
  }

  get densityActual() {
    return this._data.densityActual
  }

  set densityActual(densityActual) {
    this._data.densityActual = densityActual
  }

  get dimensionsActual() {
    return this._data.dimensionsActual
  }

  set dimensionsActual(dimensionsActual) {
    this._data.dimensionsActual = dimensionsActual
  }

  get quantityStation() {
    return this._data.quantityStation
  }

  set quantityStation(quantityStation) {
    this._data.quantityStation = quantityStation
  }

  get weightStation() {
    return this._data.weightStation
  }

  set weightStation(weightStation) {
    this._data.weightStation = weightStation
  }

  get cubageStation() {
    return this._data.cubageStation
  }

  set cubageStation(cubageStation) {
    this._data.cubageStation = cubageStation
  }

  get chargeWeightStation() {
    return this._data.chargeWeightStation
  }

  set chargeWeightStation(chargeWeightStation) {
    this._data.chargeWeightStation = chargeWeightStation
  }

  get densityStation() {
    return this._data.densityStation
  }

  set densityStation(densityStation) {
    this._data.densityStation = densityStation
  }

  get dimensionsStation() {
    return this._data.dimensionsStation
  }

  set dimensionsStation(dimensionsStation) {
    this._data.dimensionsStation = dimensionsStation
  }

  get freightAmount() {
    return this._data.freightAmount
  }

  set freightAmount(freightAmount) {
    this._data.freightAmount = freightAmount
  }

  get freightType() {
    return this._data.freightType
  }

  set freightType(freightType) {
    this._data.freightType = freightType
  }

  get freightCurrency() {
    return this._data.freightCurrency
  }

  set freightCurrency(freightCurrency) {
    this._data.freightCurrency = freightCurrency
  }

  get signatureWeight() {
    return this._data.signatureWeight
  }

  set signatureWeight(signatureWeight) {
    this._data.signatureWeight = signatureWeight
  }

  get signatureDimensions() {
    return this._data.signatureDimensions
  }

  set signatureDimensions(signatureDimensions) {
    this._data.signatureDimensions = signatureDimensions
  }

  get signatureRemark() {
    return this._data.signatureRemark
  }

  set signatureRemark(signatureRemark) {
    this._data.signatureRemark = signatureRemark
  }

  get foldedWeightRemark() {
    return this._data.foldedWeightRemark
  }

  set foldedWeightRemark(foldedWeightRemark) {
    this._data.foldedWeightRemark = foldedWeightRemark
  }

  get routeConfirmationStatus() {
    return this._data.routeConfirmationStatus
  }

  set routeConfirmationStatus(routeConfirmationStatus) {
    this._data.routeConfirmationStatus = routeConfirmationStatus
  }

  get routeConfirmationUser() {
    return this._data.routeConfirmationUser
  }

  set routeConfirmationUser(routeConfirmationUser) {
    this._data.routeConfirmationUser = routeConfirmationUser
  }

  get routeConfirmationDate() {
    return this._data.routeConfirmationDate
  }

  set routeConfirmationDate(routeConfirmationDate) {
    this._data.routeConfirmationDate = routeConfirmationDate
  }

  get secondaryRouteConfirmationUser() {
    return this._data.secondaryRouteConfirmationUser
  }

  set secondaryRouteConfirmationUser(secondaryRouteConfirmationUser) {
    this._data.secondaryRouteConfirmationUser = secondaryRouteConfirmationUser
  }

  get secondaryRouteConfirmationDate() {
    return this._data.secondaryRouteConfirmationDate
  }

  set secondaryRouteConfirmationDate(secondaryRouteConfirmationDate) {
    this._data.secondaryRouteConfirmationDate = secondaryRouteConfirmationDate
  }
}
